// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nrx8w1Yin9A5X6ET5XtU{margin-bottom:29px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `nrx8w1Yin9A5X6ET5XtU`
};
export default ___CSS_LOADER_EXPORT___;
